import { render } from "./LearningPlans.vue?vue&type=template&id=15f66e02"
import script from "./LearningPlans.vue?vue&type=script&lang=js"
export * from "./LearningPlans.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__